export const MY_PROFILE_DRAWER_ID = 'my-profile-drawer';
export const PERSONAL_INFO_DRAWER_ID = 'personal-info-drawer';

export const EDIT_PROFILE_INFO_DRAWER_IDS = {
  email: 'edit-email',
  name: 'edit-name',
  password: 'edit-password',
  phone: 'edit-phone',
} as const;
